import bus from '../utils/bus';

export default function useFlashMessage() {
    function flashMessage(message, type = 'success') {
        bus.emit('flash', { message, type });
    }

    return { flashMessage };
}